import React, { useEffect, useRef } from 'react';
import Fireworks from 'fireworks-js';

const FireworksComponent = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;

    if (container) {
      const fireworks = new Fireworks(container, {
        speed: 2,
        acceleration: 2,
        friction: 0.98,
        gravity: 1,
        particles: 50,
        trace: 3,
        explosion: 5,
        sound: false,
      });

      fireworks.start();

      return () => {
        fireworks.stop();
      };
    }
  }, []);

  return (
    <div
      ref={containerRef}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
      }}
    />
  );
};

export default FireworksComponent;
